var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 102.7 111.6"
    },
    viewBox: "0 0 102.7 111.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#264f26}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2_00000102539336044593773200000008746994232278780301_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6 101C14.4 109.3-9.8 79.7 3.9 53.7c8.8-16.2 29-22.2 45.1-13.5h.1c25.7 14.3 21.7 52.3-6.5 60.8zm0 0c22.2-6.6 30.7-34.2 15.9-52C44 31.2 15.6 33.9 4.7 54.1c-13.8 25.6 10 55.1 37.9 46.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1 61.8c6.9 23-17.6 43.1-38.9 31.8C7 86.8 1.8 69.4 9.2 56.5c11.6-21.1 43-17.7 49.9 5.3zm0 0C52.2 39 21.2 35.9 9.9 56.9 3 69.3 8 86.3 20.6 92.9c20.9 11.3 45.2-8.2 38.5-31.1z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6 111.6c-29.4-.1-44.2-35.4-23.6-56.4 13-13 34.1-13 47.1 0 20.6 21 5.8 56.3-23.5 56.4zm0 0c23.2.1 39.2-24 30.1-45.3-11.4-26.5-48.7-26.5-60.1 0-9.2 21.3 6.7 45.4 30 45.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5 78.7c0 24-29.1 36.2-46.3 19.4-10.7-10.3-10.7-28.4 0-38.7 17.2-16.9 46.3-4.7 46.3 19.3zm0 0c-.1-23.8-29-35.6-45.7-18.7-10.2 9.9-10.2 27.6 0 37.5 16.8 16.9 45.6 5.1 45.7-18.8zM30 26.7l-5.9 11.5-.1.1c-3.9-2-7.8-4-11.7-6.1l-.2-.1v-.2l-2.7-8.7V23l.1-.2 4-5.7c.1-.1.1-.1.3-.2l7-2.1.1-.1.1.1 6.6 2.7c.8 2.7 1.8 6.5 2.4 9.2zm0 0c-.9-2.5-2.1-6-3-8.6l.2.2c-2.2-.8-4.3-1.7-6.5-2.5h.3l-7 2.1.2-.2-3.9 5.7.1-.4 2.6 8.8-.2-.3c3.8 2 7.5 4.2 11.2 6.3l-.3.1L30 26.7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 23.1c2.5 0 5 .1 7.5.4 2-.6 4-1.2 6-1.7l-.2.1c1.3-1.4 2.7-2.7 4.2-4-1.1 1.6-2.4 3.1-3.6 4.6h-.1c-2 .7-4 1.3-6.1 1.9-2.6-.3-5.2-.7-7.7-1.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 15.3c1.2 2.2 2.2 4.4 3.1 6.8.1 4 .1 8 0 12 0 1.3-.1 2.6-.2 4-.1-1.3-.2-2.6-.4-3.9-.3-4-.4-7.9-.5-11.9-.8-2.2-1.5-4.5-2-7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 38c-2.3-4.6-4.6-9.2-6.7-13.8-1.4-2.1-2.5-4.4-3.2-6.7 1.6 1.9 3 4.1 4.1 6.4C20 28.5 22 33.2 23.9 38z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.9c1.1-3 2.8-5.7 5-7.9-1.1 2.9-2.8 5.6-5 7.9zM23.5 22.2c2.5.9 4.8 2.4 6.5 4.5-2.5-.9-4.8-2.5-6.5-4.5zM12.5 0c1.8 3.5 2.9 7.4 3.4 11.3C14.1 7.8 13 3.9 12.5 0zM21.5 10.9c.3-3 1.4-5.8 3-8.3-.4 3-1.4 5.8-3 8.3zM10.9 14.1c-2.7-1.2-5.1-3-7-5.3 2.7 1.2 5.1 3 7 5.3z",
    className: "st0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.2a46dc0b0db023588109bee83fa374b1.svg";
export { ForwardRef as ReactComponent };